/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import QRCode from 'react-qr-code';
import {toast} from 'react-toastify';
import {AppLocator} from '../../../../../../app-locator';
import HasPermission from '../../../../auth/HasPermission';
import {Video} from '../../../vidoes.types';
import {shareVideo} from '../../../vidoes.api';

const APP_URL = process.env.REACT_APP_APP_URL;
const productionMode = process.env.NODE_ENV === 'production';

interface Props {
  video: Video;
}

const VideoSharingWindow = ({video}: Props) => {
  const [copied, setCopied] = useState(false);
  const [enableShare, setEnableShare] = useState(true);
  const [sharedLink, setSharedLink] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const appUrl = productionMode
    ? `https://${window.location.hostname}`
    : `http://${window.location.hostname}:3011`;

  const copy = () => {
    setCopied(true);
  };

  const copyEmbedCode = () => {
    const _code = embed_code.replace('shared_link', `${APP_URL}/models/ar-app?id=${video.pub_id}`);
    navigator.clipboard.writeText(_code);
    toast.success('Embed code copied');
  };

  const share = async () => {
    if (!video.pub_id) return;

    setIsSaving(true);

    try {
      await shareVideo(video.pub_id);

      toast.success(`3D Experience shared successfully`);
      setIsSaving(false);
    } catch (error) {
      console.error('[share 3D Experience]', error);
      toast.error('Oops, Sharing 3D Experience failed');
      setIsSaving(false);
    }
  };

  useEffect(() => {
    share();
  }, [video]);

  useEffect(() => {
    setSharedLink(`${appUrl}/videos/share?id=${video.pub_id}`);
  }, [video.pub_id]);

  useEffect(() => {
    if (copied)
      setTimeout(() => {
        setCopied(false);
      }, 1500);
  }, [copied]);

  return (
    <>
      <div>
        <div className='text-gray-500 mb-5'>
          When sharing this 3D Experience, anyone with the link can view this 3D Experience. Once 3D
          Experience is shared, shared can't be disabled.
        </div>

        {/* toggle */}
        {/* <div className='row mb-3'>
          <label className='col-sm-3 col-form-label'>Enable sharing:</label>

          <div className='col-sm-9'>
            <label className='form-check form-switch form-check-custom form-check-solid mt-2'>
              <input
                className='form-check-input'
                type='checkbox'
                defaultChecked={enableShare}
                onClick={() => setEnableShare(!enableShare)}
              />
              <span className='form-check-label text-muted'>
                {enableShare ? 'Model shared' : 'Model not shared'}
              </span>
            </label>
          </div>
        </div> */}

        {isSaving && (
          <div className='text-center mt-10'>
            {enableShare && <span>Sharing 3D Experience, please wait...</span>}
            {!enableShare && <span>Disable 3D Experience sharing, please wait...</span>}
          </div>
        )}

        {enableShare && !isSaving && (
          <div>
            {/* link */}
            <div className='row mb-3'>
              <label className='col-sm-3 col-form-label'>Link:</label>

              <div className='col-sm-9'>
                <div className=' input-group mb-5'>
                  <input
                    id='input'
                    type='text'
                    className='form-control'
                    value={sharedLink}
                    disabled
                    placeholder='Generating link...'
                  />
                  <OverlayTrigger
                    key='copy-to-clipboard'
                    placement='top'
                    show={copied}
                    overlay={<Tooltip id='tooltip-copy-to-clipboard'>Copied!</Tooltip>}
                  >
                    <CopyToClipboard text={sharedLink} onCopy={() => setCopied(true)}>
                      <span className='input-group-text cursor-pointer ' onClick={copy}>
                        {!copied && <i className='fas fa-clipboard fs-4 '></i>}
                        {copied && (
                          <i className='fas fa-clipboard-check fs-4 text-primary animation  animate__heartBeat'></i>
                        )}
                      </span>
                    </CopyToClipboard>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            {/* link */}
            {/* <HasPermission code='models.embedded-script'>
              <div className='row mb-3'>
                <label className='col-sm-3 col-form-label'>Embed code:</label>

                <div className='col-sm-9'>
                  <a
                    onClick={copyEmbedCode}
                    className='btn btn-link btn-color-muted btn-active-color-primary'
                  >
                    Copy embed code
                  </a>
                </div>
              </div>
            </HasPermission> */}

            {/* QR */}
            <div className='row mb-3'>
              <label className='col-md-3 col-form-label'>QR code:</label>

              <div className='col-md-7 col-sm-12 '>
                <div className='w-fit'>
                  <QRCode
                    className='h-200px'
                    style={{height: 'auto', maxWidth: '100%', width: '100%'}}
                    value={sharedLink}
                    viewBox={`0 0 256 256`}
                  />
                </div>
                <div className='text-muted mt-2'>Scan QR code by mobile to get shared link</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const embed_code =
  '<a href="javascript:window.open( \'https://console.vree.ai/models/ar-app?id=e9629bd1257909044385ad21e190cc760636f5d5\', \'\', `height=${screen.availHeight * 0.8},width=${screen.availWidth * 0.8},toolbar=no,directories=no,status=no, linemenubar=no,scrollbars=no,resizable=yes ,modal=yes` );;" rel="noopener noreferrer" style=" background: rgb(83, 122, 252); color: white; padding: 10px 15px; border-radius: 13px; text-decoration: none; " > <span style="position: relative; top: 7px; padding-right: 5px" ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > <path opacity="0.3" d="M3 6C2.4 6 2 5.6 2 5V3C2 2.4 2.4 2 3 2H5C5.6 2 6 2.4 6 3C6 3.6 5.6 4 5 4H4V5C4 5.6 3.6 6 3 6ZM22 5V3C22 2.4 21.6 2 21 2H19C18.4 2 18 2.4 18 3C18 3.6 18.4 4 19 4H20V5C20 5.6 20.4 6 21 6C21.6 6 22 5.6 22 5ZM6 21C6 20.4 5.6 20 5 20H4V19C4 18.4 3.6 18 3 18C2.4 18 2 18.4 2 19V21C2 21.6 2.4 22 3 22H5C5.6 22 6 21.6 6 21ZM22 21V19C22 18.4 21.6 18 21 18C20.4 18 20 18.4 20 19V20H19C18.4 20 18 20.4 18 21C18 21.6 18.4 22 19 22H21C21.6 22 22 21.6 22 21ZM16 11V9C16 6.8 14.2 5 12 5C9.8 5 8 6.8 8 9V11C7.2 11 6.5 11.7 6.5 12.5C6.5 13.3 7.2 14 8 14V15C8 17.2 9.8 19 12 19C14.2 19 16 17.2 16 15V14C16.8 14 17.5 13.3 17.5 12.5C17.5 11.7 16.8 11 16 11ZM13.4 15C13.7 15 14 15.3 13.9 15.6C13.6 16.4 12.9 17 12 17C11.1 17 10.4 16.5 10.1 15.7C10 15.4 10.2 15 10.6 15H13.4Z" fill="currentColor"/> <path d="M9.2 12.9C9.1 12.8 9.10001 12.7 9.10001 12.6C9.00001 12.2 9.3 11.7 9.7 11.6C10.1 11.5 10.6 11.8 10.7 12.2C10.7 12.3 10.7 12.4 10.7 12.5L9.2 12.9ZM14.8 12.9C14.9 12.8 14.9 12.7 14.9 12.6C15 12.2 14.7 11.7 14.3 11.6C13.9 11.5 13.4 11.8 13.3 12.2C13.3 12.3 13.3 12.4 13.3 12.5L14.8 12.9ZM16 7.29998C16.3 6.99998 16.5 6.69998 16.7 6.29998C16.3 6.29998 15.8 6.30001 15.4 6.20001C15 6.10001 14.7 5.90001 14.4 5.70001C13.8 5.20001 13 5.00002 12.2 4.90002C9.9 4.80002 8.10001 6.79997 8.10001 9.09997V11.4C8.90001 10.7 9.40001 9.8 9.60001 9C11 9.1 13.4 8.69998 14.5 8.29998C14.7 9.39998 15.3 10.5 16.1 11.4V9C16.1 8.5 16 8 15.8 7.5C15.8 7.5 15.9 7.39998 16 7.29998Z" fill="currentColor"/> </svg> </span> <span> Try it on your face</span> </a>';

export default VideoSharingWindow;
